module.exports = __webpack_public_path__ + "img/student-svg.5af90d30.svg";